import { useQuery } from '@tanstack/react-query';
import type { ApiKeyQuery } from '../types';
import { ApiKeysService } from '../services';

/**
 * Hook para buscar lista de API Keys com paginação e filtros
 *
 * @example
 * const { data, isLoading, error } = useApiKeys({ page: 1, limit: 12, status: 'active' });
 */
export const useApiKeys = (query?: ApiKeyQuery) => {
  return useQuery({
    queryKey: ['api-keys', query],
    queryFn: ({ signal }) => ApiKeysService.getApiKeys(query, signal),
    staleTime: 2 * 60 * 1000, // 2 minutes - API keys podem mudar frequentemente
  });
};
